//Install
import React, { Component } from "react";
//Install
import { Container, Row, Col } from "react-bootstrap";
//Install
import Header from "../../Header";
//Install
import Footer from "../../Footer";
//Install
import T723BA from "../../../Media/Image/038.jpg";

//Element
class Default extends Component {
    //Element
    componentDidMount() {
        //Element
        document.title = "Kariyer : Temas Elektrik Taahhüt"
        //Element
        document.getElementsByTagName("meta")["description"].content = "Temas Elektrik Taahhüt, Sunduğu Hizmetleri Yürütürken Çevresel, Sosyal ve Ekonomik Sorumlulukları Öncelikli Olarak Benimsemektedir."
        //Element
        let URL = "https://temaselektrik.com/kariyer"
        //Element
        let Canonical = document.querySelector("link[rel='canonical']")
        //Element
        Canonical.setAttribute("href", URL);
    }
    //Element
    render() {
        //Element
        const Content = React.createElement("div", { className: "website-application" },
            //Element
            React.createElement(Header, {}),
            //Element
            React.createElement("main", { className: "S6pt64 C96Q4r pEO064 a527eB d3c437" },
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB f1d74t" },
                    //Element
                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB p33e0e" },
                        //Element
                        React.createElement("figure", { className: "S6pt64 C96Q4r pEO064 a527eB q84s6o" })
                    )
                ),
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB gq620v" },
                    //Element
                    React.createElement(Container, {},
                        //Element
                        React.createElement(Row, {},
                            //Element
                            React.createElement(Col, { md: 12 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB v431h7" },
                                    //Element
                                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB yk8549" },
                                        //Element
                                        React.createElement("h1", { className: "S6pt64 C96Q4r pEO064 a527eB u7760y" },
                                            //Element
                                            "Kariyer"
                                        )
                                    )
                                )
                            ),
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB q95k0u" },
                                    //Element
                                    React.createElement("h2", { className: "S6pt64 C96Q4r pEO064 a527eB q887o2" },
                                        //Element
                                        "Tutkunu İşe ",
                                        //Element
                                        React.createElement("strong", {},
                                            //Element
                                            "Dönüştür, "
                                        ),
                                        //Element
                                        "Sınırları Zorla"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Temas Elektrik Taahhüt Enerjiyi Sadece Dönüştürmüyor Bununla Beraber Bugünün ve Geleceğin Yeteneklerinide Yetiştiriyor. Dinamik Çalışma Ortamımızda, Yeteneklerini Geliştirebilir ve Sektörde Fark Yaratan Çözümler Üretebilirsin."
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Ekibimizin Bir Parçası Olarak Yaratıcılığını Özgürce İfade Edebilir Kesintisiz Öğrenme ve Gelişme Fırsatlarına Erişebilir ve Birlikte Daha Sürdürülebilir Bir Geleceğe Katkıda Bulunabilirsin."
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Bizim İçin Her Çalışan, Enerji ve Modernizasyon Zincirinin Olmazsa Olmaz Bir Parçasıdır. Temas Elektrik’te Kariyer Sadece Bir İş değil Geleceğe Yapılan Bir Yatırımdır."
                                    ),
                                    //Element
                                    React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB n82j8n", href: "mailto:ibrahim@temaselektrik.com" },
                                        //Element
                                        "Hemen Başvur"
                                    )
                                )
                            ),
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement("picture", { className: "S6pt64 C96Q4r pEO064 a527eB e649gp" },
                                    //Element
                                    React.createElement("img", { alt: "Kariyer", title: "Kariyer", src: T723BA, width: "636", height: "auto" })
                                )
                            )
                        )
                    )
                )
            ),
            //Element
            React.createElement(Footer, {})
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Default;